import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Form } from 'antd'

import LessonCreate from './LessonCreate'
import { withTour } from '../../../../../components/Tour/withTour'

import actions from '../../../../../store/actions'

import * as lessonBuilderActions from '../../../../../store/actions/lessonBuilder'

const { handleLessonClone } = actions.lessonBuilder

const WrappedLessonCreate = Form.create({ name: 'lesson_create' })(LessonCreate)

export default withTour(
  connect(
    state => ({
      lesson: state.lessonBuilder,
      courseId: state.courseBuilder.courseId,
      courseMarketPlaceDescription: state.courseBuilder.courseMarketPlaceDescription,
      topics: state.topics
    }),
    dispatch => ({
      lessonBuilderActions: bindActionCreators(lessonBuilderActions, dispatch),
      handleLessonClone: bindActionCreators(handleLessonClone, dispatch),
      upload: (file, opts) => dispatch(actions.library.upload(file, opts)),
      updateTopicList: (newTopic) => dispatch(actions.topics.updateTopicList(newTopic))
    })
  )(WrappedLessonCreate)
)
